import React, { useState, useEffect } from 'react';
import CreatableSelect from 'react-select/creatable';
import AsyncSelect from 'react-select/async';
import Select, { components } from 'react-select';

import LabelQuestion from './LabelQuestion';
import { useAutoTranslation } from '../../helpers/useAutoTranslation';

const Option = (props) => {
  if (props.data.__isNew__) {
    const newChildren = (
      <div style={{ paddingBottom: '5px', display: 'flex', alignItems: 'center' }}>
        <i className="fe-plus-circle mr-1" style={{ color: '#6658dd', fontSize: '20px' }} />
        {props.children}
      </div>
    );
    return (
      <components.Option {...props} children={newChildren} className="react-select__option-new" />
    );
  }
  return <components.Option {...props} />;
};

const SelectComponent = (props) => {
  const {
    value,
    id,
    label,
    options,
    error,
    isDisabled = false,
    isCreatable = false,
    isAsync = false,
    isSearchable = Boolean(props.isCreatable || props.isAsync),
    placeholder = '',
    showValidation,
    labelStyle = {},
    inputClassName,
    labelClassName,
    menuPortalTarget = false,
    menuIsOpen,
    onChange,
    isMulti = false,
    loadOptions = null,
    defaultOptions = [],
    noOptionsMessage = 'Нет доступных свойств',
    labelQuestion,
    defaultInputValue = '',
    onInputChange = () => false,
    debugMode = false,
    isResetOnBlur = false,
    isClearable = true,
    defaultValue = null,
    ...passedProps
  } = props;

  const [inputValue, setInputValue] = useState(value?.value ?? defaultInputValue);

  const { t } = useAutoTranslation();

  useEffect(() => {
    if (isSearchable && value?.label) {
      setInputValue(value.label);
    }
  }, [value?.label]);

  let labelClass = labelClassName ? labelClassName : '';

  const handleChange = (data, actionData) => {
    if (isSearchable && actionData?.action === 'clear') {
      setInputValue('');
    }
    onChange(data);
  };

  const handleBlur = () => {
    if (isResetOnBlur && isSearchable && value?.label) {
      setInputValue(value.label);
    }
  };

  const handleInputChange = (value, action) => {
    if (!isSearchable) {
      onInputChange(value, action);
      return false;
    }

    if (action.action !== 'input-blur' && action.action !== 'menu-close') {
      onInputChange(value);

      if (action.action === 'set-value' && !value) {
        return false;
      }

      setInputValue(value);
    }
  };

  let SelectComponent = Select;
  if (isCreatable) {
    SelectComponent = CreatableSelect;
  }
  if (isAsync) {
    SelectComponent = AsyncSelect;
  }

  const translateOptions = (options) =>
    options?.map((o) => ({
      value: o.value,
      label: t(o.label),
    }));

  const translateDefaultValue = (obj) => {
    if (!obj) return null;
    return {
      value: obj.value,
      label: obj.label ? t(obj.label) : obj.label,
    };
  };

  return (
    <>
      {label ? (
        <LabelQuestion
          label={label}
          labelClass={labelClass}
          htmlFor={id}
          style={labelStyle}
          question={labelQuestion}
        />
      ) : null}
      <SelectComponent
        className={`react-select-container ${isSearchable && 'react-select-container-saved-value'}`}
        classNamePrefix="react-select"
        createOptionPosition="first"
        formatCreateLabel={(value) => (
          <span>
            {t('Создать')} <strong>{value ? t(value) : value}</strong>
          </span>
        )}
        isDisabled={isDisabled}
        isMulti={isMulti}
        value={value}
        isSearchable={isSearchable}
        inputValue={isSearchable ? inputValue : ''}
        placeholder={placeholder}
        onChange={handleChange}
        onInputChange={handleInputChange}
        options={translateOptions(options)}
        components={{ Option }}
        noOptionsMessage={() => noOptionsMessage}
        menuPortalTarget={menuPortalTarget}
        loadOptions={loadOptions}
        defaultOptions={defaultOptions}
        menuIsOpen={menuIsOpen}
        onBlur={handleBlur}
        styles={{
          control: (provided) => ({ ...provided, minHeight: 36, height: 36 }),
        }}
        isClearable={isClearable}
        defaultValue={defaultValue}
        {...passedProps}
      />
      {error && <div className="invalid-feedback invalid-feedback__not-empty">{error}</div>}
    </>
  );
};

export default SelectComponent;
